module.exports = __webpack_public_path__ + "static/media/fa-light-300.2a3cdc72.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-light-300.woff
// module id = 768
// module chunks = 0